import React, { PureComponent } from "react";
import { getToken, removeAll, getCaptchaKey, getMfaDeviceId } from "utils/storage";
import { isObject, getLoginStatus } from "utils/methods";

import { Notification } from "element-react";
import { message } from "antd";

const notification = Notification;
const codeMessage = {
  200: "服务器成功返回请求的数据。",
  201: "新建或修改数据成功。",
  202: "一个请求已经进入后台排队（异步任务）。",
  204: "删除数据成功。",
  400: "发出的请求有错误，服务器没有进行新建或修改数据的操作。",
  401: "登录超时，请重新登录。",
  403: "用户得到授权，但是访问是被禁止的。",
  404: "发出的请求针对的是不存在的记录，服务器没有进行操作。",
  406: "请求的格式不可得。",
  410: "请求的资源被永久删除，且不会再得到的。",
  422: "当创建一个对象时，发生一个验证错误。",
  500: "服务器发生错误，请检查服务器。",
  502: "网关错误。",
  503: "服务不可用，服务器暂时过载或维护。",
  504: "网关超时。",
};

const checkServerCode = (response) => {
  let loginStatus = getLoginStatus("post");
  if (response.code >= 200 && response.code < 300) {
    return response;
  }
  // switch (response.code) {
  //   case 400:
  //     notification.error({
  //       message: codeMessage[response.code],
  //     });
  //     break;

  //   case 401:
  //     if (!loginStatus) {
  //       return false
  //     } else {
  //       notification.error({
  //         message: codeMessage[response.code],
  //       });
  //       removeAll();
  //       this.props.history.push('/sso');
  //     }
  //     break;

  //   case 404:
  //     notification.error({
  //       message: codeMessage[response.code],
  //     });
  //     break;

  //   case 500:
  //     notification.error({
  //       message: codeMessage[response.code],
  //     });
  //     break;
  // }

  return response;
};

export default class Http extends PureComponent {
  /*
   *  get请求
   *  url:请求地址
   *  data:参数
   *  callback:回调函数
   * */
  static get(url, params, callback) {
    let loginStatus = getLoginStatus("get");
    params.tenantId = "894699";
    if (params) {
      let paramsArray = [];
      //拼接参数
      Object.keys(params).forEach((key) =>
        paramsArray.push(key + "=" + params[key])
      );
      if (url.search(/\?/) === -1) {
        url += "?" + paramsArray.join("&");
      } else {
        url += "&" + paramsArray.join("&");
      }
    }

    let header = {
      Authorization: "Basic c3dvcmQ6c3dvcmRfc2VjcmV0",
      "Content-Type": "application/x-www-form-urlencoded",
      "Mfa-Device-Id": getMfaDeviceId(),
      // "content-Type": "application/json;charset=utf-8",
    };
    if (loginStatus) {
      const token = getToken();
      header["Blade-Auth"] = token;
    }
    fetch(url, {
      method: "GET",
      headers: header,
    })
      .then((response) => response.json())
      .then(checkServerCode)
      .then((responseJson) => {
        callback(responseJson);
        if (responseJson.code == 401) {
          removeAll();
          window.location = "/login";
          message.error("请先登录");
        }
      })
      .catch((err) => {
        console.log("------http get err------", err);
        //失败返回
        // callback(-1);

        const { response } = err;
        if (response && response.status) {
          const { status, url } = response;
          if (status === 401) {
            message.info("登录失效，请重新登录");
          }
        }
      });
  }

  static getApplication(url, params, callback) {
    // params.tenantId = '894699';
    if (params) {
      let paramsArray = [];
      //拼接参数
      Object.keys(params).forEach((key) =>
        paramsArray.push(key + "=" + params[key])
      );
      if (url.search(/\?/) === -1) {
        url += "?" + paramsArray.join("&");
      } else {
        url += "&" + paramsArray.join("&");
      }
    }
    const token = getToken();
    var header = {
      "Blade-Auth": token,
      Authorization: "Basic c3dvcmQ6c3dvcmRfc2VjcmV0",
    };
    fetch(url, {
      method: "GET",
      headers: header,
    })
      .then((response) => response.json())
      .then(checkServerCode)
      .then((responseJson) => {
        callback(responseJson);
        if (responseJson.code == 401) {
          removeAll();
          window.location = "/login";
          message.error("请先登录");
        }
      })
      .catch((error) => {
        //失败返回
        callback(-1);
        console.log(error);
        const { response } = error;
        if (response && response.status) {
          const { status, url } = response;
          if (status === 401) {
            message.info("登录失效，请重新登录");
          }
        }
      });
  }

  /*
   *  getProduct产品详情页获取请求
   *  url:请求地址
   *  data:参数
   *  callback:回调函数
   * */
  static getProduct(url, params, token, callback) {
    if (params) {
      let paramsArray = [];
      //拼接参数
      Object.keys(params).forEach((key) =>
        paramsArray.push(key + "=" + params[key])
      );
      if (url.search(/\?/) === -1) {
        url += "?" + paramsArray.join("&");
      } else {
        url += "&" + paramsArray.join("&");
      }
    }
    if (token) {
      var header = {
        "Blade-Auth": token,
      };
    } else {
      var header = {};
    }
    fetch(url, {
      method: "GET",
      headers: header,
    })
      .then((response) => response.json())
      .then(checkServerCode)
      .then((responseJson) => {
        callback(responseJson);
      })
      .catch((error) => {
        //失败返回
        callback(-1);
        console.log(error);
      });
  }

  /*
   *  post请求
   *  url:请求地址
   *  data:参数
   *  callback:回调函数
   * */

  static toQueryString(obj) {
    return obj
      ? Object.keys(obj)
          .sort()
          .map(function (key) {
            let val = obj[key];
            if (Array.isArray(val)) {
              return val
                .sort()
                .map(function (val2) {
                  return (
                    encodeURIComponent(key) + "=" + encodeURIComponent(val2)
                  );
                })
                .join("&");
            }

            return encodeURIComponent(key) + "=" + encodeURIComponent(val);
          })
          .join("&")
      : "";
  }

  static post(url, params, callback) {
    let loginStatus = getLoginStatus("post");
    let body = "";
    let dataType = params.dataType || "json";
    var header = {
      Authorization: "Basic c3dvcmQ6c3dvcmRfc2VjcmV0",
      "Tenant-Id": 894699,
    };
    if (dataType == "json") {
      header["Content-Type"] = "application/json;charset=utf-8";
      body = JSON.stringify(params);
    } else {
      header["Content-Type"] = "application/x-www-form-urlencoded";
      body = this.toQueryString(params);
    }
    if (loginStatus || true) {
      const token = getToken();
      if (token) {
        header["Blade-Auth"] = token;
      }
    }

    fetch(url, {
      method: "POST",
      headers: { ...header },
      body,
    })
      .then((response) => response.json())
      .then(checkServerCode)
      .then((responseJson) => {
        callback(responseJson);
        if (responseJson.code == 401) {
          removeAll();
          window.location = "/login";
          message.error("请先登录");
        }
      })
      .catch((e) => {
        const status = e.name;
        console.log("status", status, e);
        if (status === 401) {
          this.props.history.push("/login");
          return;
        }
        if (status === 404) {
          this.props.history.push("/login");
          return;
        }
        const { response } = e;
        if (response && response.status) {
          const { status, url } = response;
          if (status === 401) {
            message.info("登录失效，请重新登录");
          }
          // if (status <= 504 && status >= 500) {
          //   router.push('/exception/500');
          // }
        }
      });
  }
  static postFrom(url, params, callback) {
    params.tenantId = "894699";
    // console.log('loginStatus45645645456456456',loginStatus)

    const token = getToken();
    if (token) {
      var header = {
        "Blade-Auth": token,
      };
    } else {
      console.log("window", this.props);
    }

    fetch(url, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/x-www-form-urlencoded",
        ...header,
      }),
      body: this.toQueryString(params),
    })
      .then((response) => response.json())
      .then(checkServerCode)
      .then((responseJson) => {
        callback(responseJson);
      })
      .catch((e) => {
        const status = e.name;
        console.log("status", status, e);
        if (status === 401) {
          this.props.history.push("/login");
          return;
        }
        if (status === 404) {
          this.props.history.push("/login");
          return;
        }
        // if (status <= 504 && status >= 500) {
        //   router.push('/exception/500');
        // }
      });
  }

  static postJson(url, params, callback) {
    // let loginStatus = getLoginStatus("post");
    params.tenantId = "894699";
    // console.log('loginStatus',loginStatus);
    // if (loginStatus) {
    const token = getToken();
    // console.log("token", token);
    if (token) {
      var header = {
        "Blade-Auth": token,
      };
    } else {
      console.log("window", this.props);
    }
    // } else {
    //   var header = {};
    // }
    fetch(url, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        ...header,
      }),
      body: JSON.stringify(params),
    })
      .then((response) => response.json())
      .then(checkServerCode)
      .then((responseJson) => {
        callback(responseJson);
      })
      .catch((e) => {
        const status = e.name;
        console.log("status", status);
        if (status === 401) {
          this.props.history.push("/login");
          return;
        }
        if (status === 404) {
          this.props.history.push("/login");
          return;
        }
      });
  }

  static postLogin(url, params, callback) {
    //fetch请求
    fetch(url, {
      method: "POST",
      headers: {
        Authorization: "Basic c3dvcmQ6c3dvcmRfc2VjcmV0",
        "Content-Type": "application/x-www-form-urlencoded",
        "Captcha-key": getCaptchaKey(),
        "Captcha-code": params.verificationCode || "",
        "User-Type": params.userType || "",
        "Mfa-Device-Id": getMfaDeviceId(),
        // "Tenant-Id": "150000"
        "Tenant-Id": "894699",
      },
      body: this.toQueryString({
        ...params,
        device_id: getMfaDeviceId(),
      }),
    })
      .then((response) => response.json())
      .then((responseJSON) => {
        callback(responseJSON);
      })
      .catch((error) => {
        //失败返回
        callback(-1);
      });
  }

  static getMfaSms(url, params, callback) {
    const query = {
      ...params,
      tenantId: "894699",
    };
    const qs = Object.keys(query)
      .filter((key) => query[key] !== undefined && query[key] !== null)
      .map(
        (key) =>
          encodeURIComponent(key) + "=" + encodeURIComponent(query[key])
      )
      .join("&");
    if (qs) {
      url += (url.search(/\?/) === -1 ? "?" : "&") + qs;
    }
    fetch(url, {
      method: "GET",
      headers: {
        Authorization: "Basic c3dvcmQ6c3dvcmRfc2VjcmV0",
        "Tenant-Id": "894699",
        "Mfa-Device-Id": getMfaDeviceId(),
      },
    })
      .then((response) => response.text())
      .then((text) => {
        if (!text) {
          callback({ success: false, msg: "验证码发送失败" });
          return;
        }
        try {
          callback(JSON.parse(text));
        } catch (e) {
          callback({ success: false, msg: "验证码发送失败" });
        }
      })
      .catch(() => {
        callback({ success: false, msg: "验证码发送失败" });
      });
  }

  //政务网单点登录
  static ssoLogin(url, params, callback) {
    //fetch请求
    fetch(url, {
      method: "POST",
      headers: {
        Authorization: "Basic c3dvcmQ6c3dvcmRfc2VjcmV0",
        "Content-Type": "application/x-www-form-urlencoded",
        "Captcha-code": params.uuid != "" ? params.uuid : "",
        "Tenant-Id": "150000",
      },
      body: this.toQueryString(params),
    })
      .then((response) => response.json())
      .then((responseJSON) => {
        if (callback) {
          callback(responseJSON);
        }
      })
      .catch((error) => {
        //失败返回
        if (callback) {
          callback(-1);
        }
      });
  }

  static arrPost(url, params, num, callback) {
    //fetch请求
    let yn;
    if (num === 1) {
      yn = params[params.length - 1];
      params.splice(params.length - 1, 1);
      console.log(yn);
    }
    let param;
    if (yn != "") {
      param =
        this.toQueryString({ cadreid: 1 }) + "&" + this.toQueryString(yn) + "&";
    } else {
      param = this.toQueryString({ cadreid: 1 }) + "&";
    }
    let jj = "content=";
    let content = [];
    // console.log(param);
    for (let i = 0; i < params.length; i++) {
      // console.log(JSON.stringify(params[i]));
      // jj+=JSON.stringify(params[i].content)+'&content=';
      content.push(params[i].content);
      // jj=this.toQueryString(params[0].content);
    }

    console.log(content);
    jj += JSON.stringify(content);
    console.log(jj);
    param += jj;
    console.log(param);

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: param,
    })
      .then((response) => response.json())
      .then((responseJSON) => {
        callback(responseJSON);
      })
      .catch((error) => {
        //失败返回
        console.log(error);
      });
  }

  // 互动交流的post请求
  static hdjlPost(url, params, vericode, key, callback) {
    // let loginStatus = getLoginStatus('post');
    // console.log('loginStatus', loginStatus)
    params.tenantId = "150000";
    const token = getToken();
    if (token) {
      var header = {
        "Blade-Auth": token,
      };
    } else {
      var header = {};
    }
    fetch(url, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        "Captcha-key": key,
        "Captcha-code": vericode,
        ...header,
      }),
      body: JSON.stringify(params),
    })
      .then((response) => response.json())
      .then(checkServerCode)
      .then((responseJson) => {
        callback(responseJson);
      })
      .catch((e) => {
        const status = e.name;
        if (status === 401) {
          this.props.history.push("/login");
          return;
        }
        if (status === 404) {
          this.props.history.push("/login");
          return;
        }
      });
  }

  //简单的post请求
  static simplePost(url, params, callback) {
    //fetch请求
    let yn;
    let homeurl = params.homeurl;
    params.homeurl = "";
    let param;
    // console.log(this.toQueryString(params));
    const token = getToken();

    var header = { "Content-Type": "application/x-www-form-urlencoded" };
    fetch(url, {
      method: "POST",
      headers: header,
      body: this.toQueryString(params),
    })
      .then((response) => {
        if (response.ok && response.redirected && response.url) {
          window.location = response.url;
        } else {
          if (homeurl) {
            window.location = homeurl;
          }
        }
      })
      .then((response) => response.json())
      .then((responseJSON) => {
        if (responseJSON.ok && !responseJSON.redirected) {
          window.location = url;
        } else {
          if (homeurl) {
            window.location = homeurl;
          }
        }
      })
      .catch((error) => {});
  }
}
